export type AtsAddressInfo = {
    Address1: string;
    Address2: string;
    City: string;
    Region: string;
    PostalCode: string;
    Country: string;
};

export type AtsUserMembership = {
    OrganizationId: string;
    OrganizationName: string;
    OrganizationDomain: string;
    RoleId: string;
    RoleName: string;
    Permissions: string[];
    DateLastLoginUTC: string;
};

export type AtsUserMetaData = {
    AvatarKey: string;
    AvatarEphemeralUrl: string;
    ProfileColor: string;
    MfaEnabled: boolean;
};

export class AtsUser {
    Id: string;
    EmailAddress: string;
    FirstName: string;
    LastName: string;
    DateLastLoginUTC: string;
    IsGlobalAdmin: boolean;
    Title: string;
    Department: string;
    Bio: string;
    OfficePhone: string;
    MobilePhone: string;

    Address: AtsAddressInfo;
    Memberships: AtsUserMembership[];

    MetaData: AtsUserMetaData;
}
